import { ActionTree } from 'vuex';
import { RootState } from '@/store/types';

const actions: ActionTree<RootState, RootState> = {
    showErrMsg({ commit, dispatch }, msg) {
        dispatch("clearAllMsg");
        commit('showErrMsg', msg);
    },
    clearErrMsg({ commit }) {
        commit('clearErrMsg');
    },
    showInfoMsg({ commit }, msg) {
        commit('showInfoMsg', msg);
    },
    clearInfoMsg({ commit, dispatch }) {
        dispatch("clearAllMsg");
        commit('clearInfoMsg');
    },
    clearAllMsg({ commit }) {
        commit('clearErrMsg');
        commit('clearInfoMsg');
    },
    startLoading({ commit }) {
        commit('setLoading', true);
    },
    finishLoading({ commit }) {
        commit('setLoading', false);
    },
};

export default actions;